import { defineComponent as _defineComponent } from 'vue';
import { BButton, BButtonGroup } from "bootstrap-vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectionStatus',
    props: {
        selectionSize: null
    },
    emits: ["select-all", "reset-selection"],
    setup(__props, { emit }) {
        const props = __props;
        const hasSelection = computed(() => {
            return props.selectionSize > 0;
        });
        function selectAll() {
            emit("select-all");
        }
        function resetSelection() {
            emit("reset-selection");
        }
        return { __sfc: true, props, emit, hasSelection, selectAll, resetSelection, BButton, BButtonGroup };
    }
});
